import { _ as __rest } from './tslib.es6-9c37295f.js';
import React__default from 'react';
import { createStyles, rem, Box } from '@mantine/core';
import './index-3d331313.js';
import '@mantine/dates';
import './index-120855f6.js';
import './index-ed3e7858.js';
import './index-d943196d.js';
import './useMantineLocale-69ff962c.js';
import { T as Text } from './index-bca4f215.js';
import { B as Button } from './index-5b1256a3.js';
import './index.styles-d00e47f8.js';
import { u as useTranslations } from './index-ef9bdc70.js';
import '@mantine/hooks';
import './utils-da0db738.js';
import './other-82ea32cf.js';
import './index-72b06055.js';

var useStyles = createStyles((theme, { hasOnClickFn }) => {
    return {
        root: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            gap: rem(16),
        },
        sponsorBox: {
            display: 'flex',
            gap: rem(12),
            alignItems: 'center',
            backgroundColor: theme.colors.neutral[0],
            border: `1px solid ${theme.colors.neutral[1]}`,
            borderRadius: rem(4),
            padding: '4px 12px',
            alignSelf: 'flex-start',
        },
        sponsorLogo: {
            maxHeight: rem(32),
        },
        btn: {
            minWidth: rem(180),
            [theme.fn.largerThan('sm')]: {
                alignSelf: 'flex-end',
            },
            visibility: hasOnClickFn ? 'visible' : 'hidden',
        },
    };
});

const BabyPoopForm = (_a) => {
    var { babyPoopPage, onClickFindOut, currentUrl, sponsorLogo, btnProps, styles, classNames } = _a, props = __rest(_a, ["babyPoopPage", "onClickFindOut", "currentUrl", "sponsorLogo", "btnProps", "styles", "classNames"]);
    const { t } = useTranslations();
    const { classes } = useStyles({ hasOnClickFn: Boolean(onClickFindOut) }, { name: 'BabyPoopForm', styles, classNames });
    return (React__default.createElement(Box, Object.assign({ className: classes.root }, props),
        sponsorLogo && (React__default.createElement(Box, { className: classes.sponsorBox },
            React__default.createElement(Text, { size: "p4" }, t('common.sponsoredBy')),
            React__default.createElement("img", { loading: "lazy", src: sponsorLogo, alt: "sponsor", className: classes.sponsorLogo }))),
        React__default.createElement(Text, { size: "p3", className: "description" }, babyPoopPage.description),
        React__default.createElement(Button, Object.assign({ className: classes.btn, onClick: onClickFindOut, dataEventCategory: "Health Tool", dataEventAction: "Baby Stool Inquiry", dataEventLabel: currentUrl }, btnProps), t('babyPoop.findOut'))));
};

export { BabyPoopForm as B };
